import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';

import {validateHostName, validateIpAddress} from '../../../../validators/name-servers-validator.directive';
import {ValidatorService} from '../../../../services/validator.service';
import {ValueFromAdditionalMapPipe} from '../../../../pipes/value-from-additional-map.pipe';
import {ServerConstants} from '../../../../model/ServerConstants';
import {SortIpUtilPipe} from '../sort-ip-util.pipe';
import {ErrorVO} from '../../../../generate/ErrorVO';
import {UtilService} from '../../../../util/util.service';
import {NameServerVO} from '../../../../generate/TopLevelDomainVO';

@Component({
  selector: 'name-servers-edit',
  templateUrl: './name-servers-edit.component.html',
  styleUrls: ['./name-servers-edit.component.scss']
})
export class NameserversEditComponent implements OnInit {

  @Input()
  nameServers: Array<NameServerVO>;

  @Input()
  newDelegation: boolean;


  editNameServersForm: FormGroup;
  @Output()
  nameServersEventOutPut = new EventEmitter<Array<NameServerVO>>();
  @Output()
  cancelOutPut = new EventEmitter<void>();
  minimumNSRequirement: boolean;
  errors: ErrorVO;
  serverConstants = ServerConstants;

  constructor(private formBuilder: FormBuilder, private util: UtilService, private validator: ValidatorService) {
  }


  ngOnInit() {
    this.editNameServersForm = this.formBuilder.group({
      nameservers: this.initNameServersArray()
    });
  }

  onSubmit(): void {

    const outputNameServers: Array<NameServerVO> = [];
    for (let i in this.editNameServersForm.getRawValue().nameservers) {
      const ns: NameServerVO = {};
      const formVal = this.editNameServersForm.getRawValue().nameservers[i];
      ns.hostname = formVal.host.trim();
      ns.ipAddresses = formVal.ip.split(",").filter((elem, index, self) => {
        return index === self.indexOf(elem)
      }).map(item => item.trim());
      ns.locks = formVal.locks;
      ns.new = formVal.new;
      ns.shared = formVal.shared;
      if (!this.util.checkIfEmpty(ns.hostname) && !this.util.checkIfEmpty(ns.ipAddresses.toString())) {
        outputNameServers.push(ns);
      }
    }


    this.validator.validateNameServers(outputNameServers).subscribe(data => {
      if (data == null) {
        this.nameServersEventOutPut.emit(outputNameServers);
      } else {
        this.errors = data;

        if (this.formNameServers && this.formNameServers.length < 1) {
          this.minimumNSRequirement = true;
          this.errors = {};
        }
      }
    });
  }

  cancel(): void {
    this.cancelOutPut.emit();
  }

  removeNameServer(i: number) {
    this.formNameServers.removeAt(i);
  }

  addAditionalNS() {
    this.minimumNSRequirement = false;

    this.formNameServers.push(new FormGroup({
      host: new FormControl('', [Validators.required, validateHostName]),
      ip: new FormControl('', [Validators.required, validateIpAddress])
    }));
  }

  checkIfIPError(errors): boolean {
    return errors && errors.invalidIpAddress && errors.invalidIpAddress.length > 0 && !this.util.checkIfEmpty(errors.ipAddress);
  }

  checkIfHostError(errors): boolean {
    return errors && errors.invalidHostName && !this.util.checkIfEmpty(errors.hostName);
  }

  checkIfIPErrorForCSS(c: AbstractControl): string {
    let errors = c.get("ip").errors;
    return this.checkIfIPError(errors) || this.IPValidationError(c.get('host').value, 0).length > 0 ? "input-field-error" : "";
  }

  checkIfHostErrorForCSS(c: AbstractControl): string {
    let errors = c.get("host").errors;
    return this.checkIfHostError(errors) || this.hostValidationError(c.get('host').value, 0).length > 0 ? "input-field-error" : "";
  }


  hostValidationError(val: string, i: number): string[] {
    let hostErrors: Array<string> = this.getNameServerValidationError(val, "hostname");
    if (i + 1 === this.formNameServers.length) {
      hostErrors = hostErrors.concat(this.getNameServerValidationError("$global$", "hostname"))
    }
    return hostErrors;
  }

  IPValidationError(val: string, i: number): string[] {
    let ipErrors: Array<string> = this.getNameServerValidationError(val, "ipAddress");
    if (i + 1 === this.formNameServers.length) {
      ipErrors = ipErrors.concat(this.getNameServerValidationError("$global$", "ipAddress"))
    }
    return ipErrors;
  }

  getNameServerValidationError(name: string, field: string): string[] {

    let listOfErrors: Array<string> = [];
    let error: ErrorVO = this.util.getFieldError(name, this.errors);
    let hostError: ErrorVO = this.util.getFieldError(field, error);
    if (hostError != null) {
      listOfErrors = hostError.errorMessages;
    }

    return listOfErrors;
  }


  private initNameServersArray() {
    const formArr = new FormArray([]);
    let ns: NameServerVO = {};

    if (!this.nameServers || this.nameServers.length === 0) {
      this.nameServers = [ns, ns];
    }

    this.nameServers.forEach((ns) => {
      let hostIpGroup = this.formBuilder.group({
        host: [{value: ns.hostname, disabled: this.isDisabled(ns, "UPDATE")}, [Validators.required, validateHostName]],
        ip: [{
          value: new SortIpUtilPipe().transform(ns.ipAddresses).join(","),
          disabled: this.isDisabled(ns, "UPDATE")
        }, [Validators.required, validateIpAddress]],
        locks: ns.locks,
        new: ns.new,
        shared: ns.shared
      });

      formArr.push(hostIpGroup);
    });

    return formArr;
  }

  displayValidationError(controlName: string): boolean {
    return this.util.displayValidationError(this.editNameServersForm, controlName);
  }


  get formNameServers(): FormArray {
    return this.editNameServersForm.controls['nameservers'] as FormArray;
  }

  isDisabled(ns: NameServerVO, type: string): boolean {
    return !this.util.checkIfEmpty(new ValueFromAdditionalMapPipe().transform(ns, ServerConstants.LOCK_FIELD_NAME, type));
  }
}
